import React, { Component } from "react";
import "./History.css";
import axios from "axios";
import moment from "moment";

class History extends Component {
  state = {
    todayprice: {},
    yesterdayprice: {},
    twodaysprice: {},
    threedaysprice: {},
    fourdaysprice: {}
  };
  getBTCPrices = this.getBTCPrices.bind(this);
  getETHPrices = this.getETHPrices.bind(this);
  getLTCPrices = this.getLTCPrices.bind(this);

  // This function gets the ETH price for a specific timestamp/date. The date is passed in as an argument
  getETHPrices(date) {
    return axios.get(
      "https://min-api.cryptocompare.com/data/pricehistorical?fsym=ETH&tsyms=USD&ts=" +
        date
    );
  }
  // This function gets the BTC price for a specific timestamp/date. The date is passed in as an argument
  getBTCPrices(date) {
    return axios.get(
      "https://min-api.cryptocompare.com/data/pricehistorical?fsym=BTC&tsyms=USD&ts=" +
        date
    );
  }
  // This function gets the LTC price for a specific timestamp/date. The date is passed in as an argument
  getLTCPrices(date) {
    return axios.get(
      "https://min-api.cryptocompare.com/data/pricehistorical?fsym=LTC&tsyms=USD&ts=" +
        date
    );
  }

  // This function gets the today price
  getTodayPrice() {
      let t = moment().unix()
      // axios.all is used to make concurrent API requests. These requests were the functions we first created and they accept an argument of the date required
      axios.all([this.getETHPrices(t), this.getBTCPrices(t), this.getLTCPrices(t)])
      .then(axios.spread((eth, btc, ltc) => {
        let f = {
            date: moment.unix(t).format("MMMM Do YYYY"),
            eth: eth.data.ETH.USD,
            btc: btc.data.BTC.USD,
            ltc: ltc.data.LTC.USD
        }
        // Set the state of todayprice to the content of the object f
        this.setState({ todayprice: f });
    }));
  }

    // This function gets the prices for the yesterday.
     getYesterdayPrice () {
        // Get yesterday's date in timestamp
        let t = moment().subtract(1, 'days').unix();
        // axios.all is used to make concurrent API requests. These requests were the functions we first created and they accept an argument of the date required.
        axios.all([this.getETHPrices(t), this.getBTCPrices(t), this.getLTCPrices(t)])
            .then(axios.spread((eth, btc, ltc) => {
                let f = {
                    date: moment.unix(t).format("MMMM Do YYYY"),
                    eth: eth.data.ETH.USD,
                    btc: btc.data.BTC.USD,
                    ltc: ltc.data.LTC.USD
                }
                // Set the state of yesterdayprice to the content of the object f
                this.setState({ yesterdayprice: f });
            }));
    }

    // This function gets the prices for the two days ago.
    getTwoDaysPrice () {
        // Get the date for two days ago in timestamp
        let t = moment().subtract(2, 'days').unix();
        // axios.all is used to make concurrent API requests. These requests were the functions we first created and they accept an argument of the date required.
        axios.all([this.getETHPrices(t), this.getBTCPrices(t), this.getLTCPrices(t)])
            .then(axios.spread((eth, btc, ltc) => {
                let f = {
                    date: moment.unix(t).format("MMMM Do YYYY"),
                    eth: eth.data.ETH.USD,
                    btc: btc.data.BTC.USD,
                    ltc: ltc.data.LTC.USD
                }
                // Set the state of twodaysprice to the content of the object f
                this.setState({ twodaysprice: f });
            }));
    }

    // This function gets the prices for the three days ago.
    getThreeDaysPrice () {
        // Get the date for three days ago in timestamp
        let t = moment().subtract(3, 'days').unix();
        // axios.all is used to make concurrent API requests. These requests were the functions we first created and they accept an argument of the date required.
        axios.all([this.getETHPrices(t), this.getBTCPrices(t), this.getLTCPrices(t)])
            .then(axios.spread((eth, btc, ltc) => {
                let f = {
                    date: moment.unix(t).format("MMMM Do YYYY"),
                    eth: eth.data.ETH.USD,
                    btc: btc.data.BTC.USD,
                    ltc: ltc.data.LTC.USD
                }
                // Set the state of threedaysprice to the content of the object f
                this.setState({ threedaysprice: f });
            }));
    }
    // This function gets the prices for the four days ago.
    getFourDaysPrice () {
        // Get the date for four days ago in timestamp
        let t = moment().subtract(4, 'days').unix();
        // axios.all is used to make concurrent API requests. These requests were the functions we first created and they accept an argument of the date required.
        axios.all([this.getETHPrices(t), this.getBTCPrices(t), this.getLTCPrices(t)])
            .then(axios.spread((eth, btc, ltc) => {
                let f = {
                    date: moment.unix(t).format("MMMM Do YYYY"),
                    eth: eth.data.ETH.USD,
                    btc: btc.data.BTC.USD,
                    ltc: ltc.data.LTC.USD
                }
                // Set the state of fourdaysprice to the content of the object f
                this.setState({ fourdaysprice: f });
            }));
    }

    componentWillMount () {
        this.getTodayPrice();
        this.getYesterdayPrice();
        this.getTwoDaysPrice();
        this.getThreeDaysPrice();
        this.getFourDaysPrice();
    }

  render() {
    return (
        <div className="history--section container">
                    <h1>Coin History (Past 5 days)</h1>
                    <div className="history-section-main-box">
                        <div className="history-section-inner-box">
                            <h4>{this.state.todayprice.date}</h4>
                            <div className="columns">
                                <div className="column">
                                    <p>1 BTC = ${this.state.todayprice.btc}</p>
                                </div>
                                <div className="column">
                                    <p>1 ETH = ${this.state.todayprice.eth}</p>
                                </div>
                                <div className="column">
                                    <p>1 LTC = ${this.state.todayprice.ltc}</p>
                                </div>
                            </div>
                        </div>
                        <p className="line"></p>

                        <div className="history-section-inner-box">
                            <h4>{this.state.yesterdayprice.date}</h4>
                            <div className="columns">
                                <div className="column">
                                    <p>1 BTC = ${this.state.yesterdayprice.btc}</p>
                                </div>
                                <div className="column">
                                    <p>1 ETH = ${this.state.yesterdayprice.eth}</p>
                                </div>
                                <div className="column">
                                    <p>1 LTC = ${this.state.yesterdayprice.ltc}</p>
                                </div>
                            </div>
                        </div>
                        <p className="line"></p>

                        <div className="history-section-inner-box">
                            <h4>{this.state.twodaysprice.date}</h4>
                            <div className="columns">
                                <div className="column">
                                    <p>1 BTC = ${this.state.twodaysprice.btc}</p>
                                </div>
                                <div className="column">
                                    <p>1 ETH = ${this.state.twodaysprice.eth}</p>
                                </div>
                                <div className="column">
                                    <p>1 LTC = ${this.state.twodaysprice.ltc}</p>
                                </div>
                            </div>
                        </div>
                        <p className="line"></p>

                        <div className="history-section-inner-box">
                            <h4>{this.state.threedaysprice.date}</h4>
                            <div className="columns">
                                <div className="column">
                                    <p>1 BTC = ${this.state.threedaysprice.btc}</p>
                                </div>
                                <div className="column">
                                    <p>1 ETH = ${this.state.threedaysprice.eth}</p>
                                </div>
                                <div className="column">
                                    <p>1 LTC = ${this.state.threedaysprice.ltc}</p>
                                </div>
                            </div>
                        </div>
                        <p className="line"></p>
                        
                        <div className="history-section-inner-box">
                            <h4>{this.state.fourdaysprice.date}</h4>
                            <div className="columns">
                                <div className="column">
                                    <p>1 BTC = ${this.state.fourdaysprice.btc}</p>
                                </div>
                                <div className="column">
                                    <p>1 ETH = ${this.state.fourdaysprice.eth}</p>
                                </div>
                                <div className="column">
                                    <p>1 LTC = ${this.state.fourdaysprice.ltc}</p>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
    )
  }
}
export default History;
